// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"f7db3fa5","295":"51d3ae46","347":"f46a7839","669":"a6cb590f","988":"eac74839"}[chunkId] + ".chunk.css";
};